import { Button } from '@/components/basic';
import {
  DialogContent,
  DialogTitle,
  DialogHeader
} from '@/components/ui/dialog';
import { CalendarIcon } from '@cmp-src/icons/TacticIcons/CalendarIcon';
import { useCallback } from 'react';
import * as V2Dialog from '@cmp-src/primitives/Dialog';
import { delegatedPermissionPartials } from '@gettactic/helpers';

interface DelegatedPermissionRequestProps {
  msAuthUrl: string;
  onClose: () => void;
}

export function DelegatedPermissionRequest({
  msAuthUrl,
  onClose
}: DelegatedPermissionRequestProps) {
  const handleConnectOutlook = useCallback(() => {
    window.open(msAuthUrl);
  }, [msAuthUrl]);

  return (
    <DialogContent className="p-6 sm:max-w-[500px]" onClose={onClose}>
      <DialogHeader>
        <DialogTitle className="font-bold text-xl">
          {delegatedPermissionPartials.title}
        </DialogTitle>
      </DialogHeader>

      <div className="flex flex-col items-center py-6 text-center">
        <div className="mb-4 rounded-full bg-gray-200 p-4 opacity-50">
          <CalendarIcon color="white" className="h-10 w-10 text-white" />
        </div>
        <p className="mb-6">
          {delegatedPermissionPartials.description}
        </p>
        <div className="grow" />
        <Button size="lg" disabled={!msAuthUrl} onClick={handleConnectOutlook}>
          {delegatedPermissionPartials.buttonText}
        </Button>
      </div>
    </DialogContent>
  );
}

export function DelegatedPermissionRequestModalV2({
  msAuthUrl,
  onClose
}: DelegatedPermissionRequestProps) {
  const handleConnectOutlook = useCallback(() => {
    window.open(msAuthUrl);
  }, [msAuthUrl]);

  return (
    <V2Dialog.Dialog open={true} onOpenChange={(value) => !value && onClose?.()}>
      <V2Dialog.DialogContent className="p-6 sm:max-w-[500px]">
      <V2Dialog.DialogHeader>
        <V2Dialog.DialogTitle className="font-bold text-xl">
          {delegatedPermissionPartials.title}
        </V2Dialog.DialogTitle>
      </V2Dialog.DialogHeader>

      <div className="flex flex-col items-center py-6 text-center">
        <div className="mb-4 rounded-full bg-gray-200 p-4 opacity-50">
          <CalendarIcon color="white" className="h-10 w-10 text-white" />
        </div>
        <p className="mb-6">
          {delegatedPermissionPartials.description}
        </p>
        <div className="grow" />
        <Button size="lg" disabled={!msAuthUrl} onClick={handleConnectOutlook}>
          {delegatedPermissionPartials.buttonText}
        </Button>
      </div>
    </V2Dialog.DialogContent>
    </V2Dialog.Dialog>
  )
}